<template>
  <div class="ua-wrap" :class="['ua-size-'+size, ringClass]" :style="customStyle">
    <img v-if="resolvedSrc" :src="resolvedSrc" :alt="name||'User'" @error="onErr" />
    <span v-else class="ua-initials">{{ initials }}</span>
    <span v-if="badge" class="ua-badge" :class="'ua-badge-'+badge"><i :class="badgeIcon"></i></span>
  </div>
</template>

<script>
/* eslint-disable */
import { uploads, flocker } from "@/api";

export default {
  name: "UserAvatar",
  props: {
    src:    { type: String, default: '' },          // raw avatar_url from server
    name:   { type: String, default: '' },          // display name for fallback initials
    size:   { type: String, default: 'md' },        // xs|sm|md|lg|xl
    ring:   { type: String, default: '' },          // '' | 'gold' | 'green' | 'red' | 'blue'
    badge:  { type: String, default: '' },          // '' | 'verified' | 'vet' | 'admin'
    bg:     { type: String, default: '' }           // optional override background
  },
  data(){ return { brokenOnce: false } },
  computed: {
    resolvedSrc(){
      if (this.brokenOnce) return '';
      var p = this.src;
      if (!p) return '';
      if (/^(https?:|data:|blob:)/i.test(p)) return p;
      // Strip any leading "uploads/" since the helper already targets that root
      var clean = p.replace(/^\/+/, '');
      var base  = (uploads || flocker || '').replace(/\/+$/, '');
      // If the base already ends in /uploads, drop the leading "uploads/" from the path
      if (/\/uploads$/i.test(base) && /^uploads\//i.test(clean)) clean = clean.replace(/^uploads\//i, '');
      return base + '/' + clean;
    },
    initials(){
      var n = (this.name || '').trim();
      if (!n) return '?';
      var parts = n.split(/\s+/);
      var a = (parts[0] || '').charAt(0);
      var b = (parts[1] || '').charAt(0);
      return ((a + b) || a || '?').toUpperCase();
    },
    ringClass(){ return this.ring ? ('ua-ring-' + this.ring) : ''; },
    badgeIcon(){
      if (this.badge === 'verified') return 'mdi mdi-check-decagram';
      if (this.badge === 'vet')      return 'mdi mdi-stethoscope';
      if (this.badge === 'admin')    return 'mdi mdi-shield-crown';
      return '';
    },
    customStyle(){
      if (!this.bg) return {};
      return { background: this.bg };
    }
  },
  methods: {
    onErr(){ this.brokenOnce = true; }
  }
};
</script>

<style scoped>
.ua-wrap{position:relative;border-radius:50%;background:#1E1E1E;display:inline-flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0;color:#BFA164;font-weight:700;}
.ua-wrap img{width:100%;height:100%;object-fit:cover;display:block}
.ua-initials{user-select:none;letter-spacing:.5px}
html[data-theme="light"] .ua-wrap{background:#F0EBE4;color:#7a5f24}

/* Sizes */
.ua-size-xs{width:24px;height:24px;font-size:10px}
.ua-size-sm{width:32px;height:32px;font-size:12px}
.ua-size-md{width:42px;height:42px;font-size:14px}
.ua-size-lg{width:64px;height:64px;font-size:22px}
.ua-size-xl{width:96px;height:96px;font-size:30px}

/* Rings */
.ua-ring-gold{box-shadow:0 0 0 2px #BFA164}
.ua-ring-green{box-shadow:0 0 0 2px #50C878}
.ua-ring-blue{box-shadow:0 0 0 2px #4FC3F7}
.ua-ring-red{box-shadow:0 0 0 2px #FF6B6B}

/* Badges */
.ua-badge{position:absolute;bottom:-2px;right:-2px;width:16px;height:16px;border-radius:50%;background:#0A0A0A;display:flex;align-items:center;justify-content:center;font-size:10px;border:1.5px solid #141414}
html[data-theme="light"] .ua-badge{background:#fff;border-color:#fff}
.ua-badge-verified{color:#50C878}
.ua-badge-vet{color:#CE93D8}
.ua-badge-admin{color:#BFA164}
.ua-size-lg .ua-badge,.ua-size-xl .ua-badge{width:22px;height:22px;font-size:13px}

/* On phones, shrink the xl avatar slightly so it doesn't dominate above-the-fold */
@media (max-width: 768px) {
  .ua-size-xl { width: 72px !important; height: 72px !important; font-size: 26px !important; }
  .ua-size-lg { width: 44px !important; height: 44px !important; font-size: 16px !important; }
}
</style>
